export enum CostLayerKind {
  Receipt = "receipt",
  Opening = "opening",
  Adjustment = "adjustment",
  Return = "return",
  Assembly = "assembly",
}
